import axiosInstance from '../utils/axiosConfig';

/**
 * Onboarding Service - API integration for the interactive walkthrough state.
 *
 * Backed by /api/employees/me/onboarding/ which stores two timestamps on the
 * authenticated user:
 *   - onboarding_completed_at: set when any walkthrough has been finished.
 *   - onboarding_dismissed_at: set when the user opts out via "Don't show again".
 *
 * The frontend uses this to decide whether to show the welcome modal on login.
 */
const ENDPOINT = '/api/employees/me/onboarding/';

const onboardingService = {
    /**
     * Read the authenticated user's onboarding state.
     * @returns {Promise<{onboarding_completed_at: string|null, onboarding_dismissed_at: string|null, should_show_welcome: boolean}>}
     */
    getState: async () => {
        const response = await axiosInstance.get(ENDPOINT);
        return response.data;
    },

    /**
     * Mark onboarding as complete. Idempotent on the backend - keeps the
     * original timestamp if already set.
     */
    markComplete: async () => {
        const response = await axiosInstance.post(ENDPOINT, { action: 'complete' });
        return response.data;
    },

    /**
     * Persist the "Don't show again" choice. Future logins will not re-prompt.
     */
    dismiss: async () => {
        const response = await axiosInstance.post(ENDPOINT, { action: 'dismiss' });
        return response.data;
    },

    /**
     * Clear both flags. Used by QA / "show me again" admin actions.
     */
    reset: async () => {
        const response = await axiosInstance.post(ENDPOINT, { action: 'reset' });
        return response.data;
    },
};

export default onboardingService;
